<script setup lang="ts">
    import { isSitemapFooterLink } from '~/utils/footerLinks';
    const config = useRuntimeConfig();
    const isExistingSitemap = (url: unknown) => isSitemapFooterLink(url, String(config.public.prodUrl));
</script>
<template>
    <div class="py-10 lg:py-5">
        <nav>
            <ul class="footer-legal-links flex flex-row flex-wrap lg:gap-16">
                <li
                    v-if="
                        $snippets['headless.footer.cookiePolicyUrl'] &&
                        !isExistingSitemap($snippets['headless.footer.cookiePolicyUrl'])
                    "
                    class="mb-4 w-1/2 lg:mb-0 lg:w-max">
                    <NuxtLink
                        class="text-xs text-black/70 duration-200 hover:text-black"
                        :to="$snippets['headless.footer.cookiePolicyUrl']">
                        {{ $snippets['headless.footer.cookiePolicyTitle'] }}
                    </NuxtLink>
                </li>
                <li
                    v-if="
                        $snippets['headless.footer.privacyPolicyUrl'] &&
                        !isExistingSitemap($snippets['headless.footer.privacyPolicyUrl'])
                    "
                    class="mb-4 w-1/2 lg:mb-0 lg:w-max">
                    <NuxtLink
                        class="text-xs text-black/70 duration-200 hover:text-black"
                        :to="$snippets['headless.footer.privacyPolicyUrl']">
                        {{ $snippets['headless.footer.privacyPolicyTitle'] }}
                    </NuxtLink>
                </li>
                <li
                    v-if="
                        $snippets['headless.footer.termsAndConditionsUrl'] &&
                        !isExistingSitemap($snippets['headless.footer.termsAndConditionsUrl'])
                    "
                    class="mb-4 w-1/2 lg:mb-0 lg:w-max">
                    <NuxtLink
                        class="text-xs text-black/70 duration-200 hover:text-black"
                        :to="$snippets['headless.footer.termsAndConditionsUrl']">
                        {{ $snippets['headless.footer.termsAndConditionsTitle'] }}
                    </NuxtLink>
                </li>
                <li
                    v-if="
                        $snippets['headless.footer.businessInformationUrl'] &&
                        !isExistingSitemap($snippets['headless.footer.businessInformationUrl'])
                    "
                    class="mb-4 w-1/2 lg:mb-0 lg:w-max">
                    <NuxtLink
                        class="text-xs text-black/70 duration-200 hover:text-black"
                        :to="$snippets['headless.footer.businessInformationUrl']">
                        {{ $snippets['headless.footer.businessInformationTitle'] }}
                    </NuxtLink>
                </li>
                <li
                    v-if="
                        $snippets['headless.footer.disclaimerUrl'] &&
                        !isExistingSitemap($snippets['headless.footer.disclaimerUrl'])
                    "
                    class="mb-4 w-1/2 lg:mb-0 lg:w-max">
                    <NuxtLink
                        class="text-xs text-black/70 duration-200 hover:text-black"
                        :to="$snippets['headless.footer.disclaimerUrl']">
                        {{ $snippets['headless.footer.disclaimerTitle'] }}
                    </NuxtLink>
                </li>
                <li class="mb-4 w-1/2 lg:mb-0 lg:w-max">
                    <NuxtLink to="/nl/sitemap/" class="text-xs text-black/70 duration-200 hover:text-black"
                        >Sitemap</NuxtLink
                    >
                </li>
            </ul>
        </nav>
    </div>
</template>

<style scoped>
    @media (width < 64rem) {
        .footer-legal-links {
            overflow-wrap: anywhere;
        }
    }
</style>
